// AUTO-GENERATED FILE. DO NOT EDIT.
// Generated by scripts/generate-facade.ts
// Named wrappers around generated operations for tree-shaking and policy enforcement.

import { withClient } from "@/lib/api/generated-client";
import { processResult } from "@/lib/api-client";
import type {
  PreviewPlansActualsImportData,
  PreviewPlansActualsImportResponses,
  ConfirmPlansActualsImportData,
  ConfirmPlansActualsImportResponses,
  ListPlansActualsDatasetsData,
  ListPlansActualsDatasetsResponses,
  GetPlansActualsDatasetData,
  GetPlansActualsDatasetResponses,
  UpdatePlansActualsDatasetMetadataData,
  UpdatePlansActualsDatasetMetadataResponses,
  ListPlansActualsDatasetImportsData,
  ListPlansActualsDatasetImportsResponses,
  DownloadPlansActualsImportOriginalData,
  DownloadPlansActualsImportOriginalResponses,
  ListPlansActualsAttachmentsData,
  ListPlansActualsAttachmentsResponses,
  UploadPlansActualsAttachmentData,
  UploadPlansActualsAttachmentResponses,
  DownloadPlansActualsAttachmentData,
  DownloadPlansActualsAttachmentResponses,
  DeletePlansActualsAttachmentData,
  DeletePlansActualsAttachmentResponses,
  ExportPlansActualsData,
  ExportPlansActualsResponses,
  GetPlansActualsReportData,
  GetPlansActualsReportResponses,
  GetApiV1MeData,
  GetApiV1MeResponses,
  GetApiV1ConfigData,
  GetApiV1ConfigResponses,
  PatchApiV1UserDefaultCompanyData,
  PatchApiV1UserDefaultCompanyResponses,
  AdminListUsersData,
  AdminListUsersResponses,
  AdminGetUserData,
  AdminGetUserResponses,
  AdminUpdateUserData,
  AdminUpdateUserResponses,
  AdminAssignRoleData,
  AdminAssignRoleResponses,
  AdminRevokeRoleData,
  AdminRevokeRoleResponses,
  AdminListCompaniesData,
  AdminListCompaniesResponses,
  AdminCreateCompanyData,
  AdminCreateCompanyResponses,
  AdminGetCompanyData,
  AdminGetCompanyResponses,
  AdminUpdateCompanyData,
  AdminUpdateCompanyResponses,
  AdminListMembersData,
  AdminListMembersResponses,
  AdminAddMemberData,
  AdminAddMemberResponses,
  AdminRemoveMemberData,
  AdminRemoveMemberResponses,
  AdminListInvitesData,
  AdminListInvitesResponses,
  AdminRevokeInviteData,
  AdminRevokeInviteResponses,
  CreateCompanyInviteData,
  CreateCompanyInviteResponses,
  GetApiV1CompaniesData,
  GetApiV1CompaniesResponses,
  ListCompanyWorkspacesData,
  ListCompanyWorkspacesResponses,
  CreateCompanyWorkspaceData,
  CreateCompanyWorkspaceResponses,
  GetWorkspaceData,
  GetWorkspaceResponses,
  PatchWorkspaceData,
  PatchWorkspaceResponses,
  DeleteWorkspaceData,
  DeleteWorkspaceResponses,
  GetWorkspaceContextData,
  GetWorkspaceContextResponses,
  GetWorkspaceIntegrationData,
  GetWorkspaceIntegrationResponses,
  GetWorkspaceIntegrationDealDatePropertiesData,
  GetWorkspaceIntegrationDealDatePropertiesResponses,
  GetWorkspaceIntegrationPipelinesData,
  GetWorkspaceIntegrationPipelinesResponses,
  PatchWorkspaceIntegrationData,
  PatchWorkspaceIntegrationResponses,
  DeleteWorkspaceIntegrationData,
  DeleteWorkspaceIntegrationResponses,
  ListDatasetsData,
  ListDatasetsResponses,
  UploadDatasetData,
  UploadDatasetResponses,
  DeleteDatasetData,
  DeleteDatasetResponses,
  GetDatasetData,
  GetDatasetResponses,
  ListDatasetRowsData,
  ListDatasetRowsResponses,
  ExportDatasetRowsCsvData,
  ExportDatasetRowsCsvResponses,
  ListDatasetFlagsData,
  ListDatasetFlagsResponses,
  GetWorkspaceDatasetChartData,
  GetWorkspaceDatasetChartResponses,
  GetWorkspaceChartData,
  GetWorkspaceChartResponses,
  GetWorkspaceDatasetArrSummaryData,
  GetWorkspaceDatasetArrSummaryResponses,
  GetWorkspaceDatasetTopAccountsData,
  GetWorkspaceDatasetTopAccountsResponses,
  GetWorkspaceDatasetAccountDealsData,
  GetWorkspaceDatasetAccountDealsResponses,
  GetWorkspaceDatasetAccountPerformanceData,
  GetWorkspaceDatasetAccountPerformanceResponses,
  ListExclusionRulesData,
  ListExclusionRulesResponses,
  CreateExclusionRuleData,
  CreateExclusionRuleResponses,
  DeleteExclusionRuleData,
  DeleteExclusionRuleResponses,
  PostWorkspaceIntegrationSyncData,
  PostWorkspaceIntegrationSyncResponses,
} from "@/lib/generated/types.gen";
import {
  previewPlansActualsImport as _previewPlansActualsImport,
  confirmPlansActualsImport as _confirmPlansActualsImport,
  listPlansActualsDatasets as _listPlansActualsDatasets,
  getPlansActualsDataset as _getPlansActualsDataset,
  updatePlansActualsDatasetMetadata as _updatePlansActualsDatasetMetadata,
  listPlansActualsDatasetImports as _listPlansActualsDatasetImports,
  downloadPlansActualsImportOriginal as _downloadPlansActualsImportOriginal,
  listPlansActualsAttachments as _listPlansActualsAttachments,
  uploadPlansActualsAttachment as _uploadPlansActualsAttachment,
  downloadPlansActualsAttachment as _downloadPlansActualsAttachment,
  deletePlansActualsAttachment as _deletePlansActualsAttachment,
  exportPlansActuals as _exportPlansActuals,
  getPlansActualsReport as _getPlansActualsReport,
  getApiV1Me as _getApiV1Me,
  getApiV1Config as _getApiV1Config,
  patchApiV1UserDefaultCompany as _patchApiV1UserDefaultCompany,
  adminListUsers as _adminListUsers,
  adminGetUser as _adminGetUser,
  adminUpdateUser as _adminUpdateUser,
  adminAssignRole as _adminAssignRole,
  adminRevokeRole as _adminRevokeRole,
  adminListCompanies as _adminListCompanies,
  adminCreateCompany as _adminCreateCompany,
  adminGetCompany as _adminGetCompany,
  adminUpdateCompany as _adminUpdateCompany,
  adminListMembers as _adminListMembers,
  adminAddMember as _adminAddMember,
  adminRemoveMember as _adminRemoveMember,
  adminListInvites as _adminListInvites,
  adminRevokeInvite as _adminRevokeInvite,
  createCompanyInvite as _createCompanyInvite,
  getApiV1Companies as _getApiV1Companies,
  listCompanyWorkspaces as _listCompanyWorkspaces,
  createCompanyWorkspace as _createCompanyWorkspace,
  getWorkspace as _getWorkspace,
  patchWorkspace as _patchWorkspace,
  deleteWorkspace as _deleteWorkspace,
  getWorkspaceContext as _getWorkspaceContext,
  getWorkspaceIntegration as _getWorkspaceIntegration,
  getWorkspaceIntegrationDealDateProperties as _getWorkspaceIntegrationDealDateProperties,
  getWorkspaceIntegrationPipelines as _getWorkspaceIntegrationPipelines,
  patchWorkspaceIntegration as _patchWorkspaceIntegration,
  deleteWorkspaceIntegration as _deleteWorkspaceIntegration,
  listDatasets as _listDatasets,
  uploadDataset as _uploadDataset,
  deleteDataset as _deleteDataset,
  getDataset as _getDataset,
  listDatasetRows as _listDatasetRows,
  exportDatasetRowsCsv as _exportDatasetRowsCsv,
  listDatasetFlags as _listDatasetFlags,
  getWorkspaceDatasetChart as _getWorkspaceDatasetChart,
  getWorkspaceChart as _getWorkspaceChart,
  getWorkspaceDatasetArrSummary as _getWorkspaceDatasetArrSummary,
  getWorkspaceDatasetTopAccounts as _getWorkspaceDatasetTopAccounts,
  getWorkspaceDatasetAccountDeals as _getWorkspaceDatasetAccountDeals,
  getWorkspaceDatasetAccountPerformance as _getWorkspaceDatasetAccountPerformance,
  listExclusionRules as _listExclusionRules,
  createExclusionRule as _createExclusionRule,
  deleteExclusionRule as _deleteExclusionRule,
  postWorkspaceIntegrationSync as _postWorkspaceIntegrationSync,
} from "@/lib/generated/sdk.gen";

/** Re-parse a Blob error payload as JSON so processResult can extract error messages. */
async function parseBlobError(error: unknown): Promise<unknown> {
  if (!(error instanceof Blob)) return error;
  try {
    return JSON.parse(await error.text());
  } catch {
    return error;
  }
}

export async function previewPlansActualsImport(
  opts: Omit<PreviewPlansActualsImportData, "url">,
): Promise<PreviewPlansActualsImportResponses[200]> {
  return withClient(async (client) => {
    const result = await _previewPlansActualsImport({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url =
      result.response?.url ?? "/api/v1/workspaces/{workspace_id}/plans-actuals/imports/preview";
    return processResult<PreviewPlansActualsImportResponses[200]>(url, result);
  });
}

export async function confirmPlansActualsImport(
  opts: Omit<ConfirmPlansActualsImportData, "url">,
): Promise<ConfirmPlansActualsImportResponses[200 | 201]> {
  return withClient(async (client) => {
    const result = await _confirmPlansActualsImport({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/workspaces/{workspace_id}/plans-actuals/imports";
    return processResult<ConfirmPlansActualsImportResponses[200 | 201]>(url, result);
  });
}

export async function listPlansActualsDatasets(
  opts: Omit<ListPlansActualsDatasetsData, "url">,
): Promise<ListPlansActualsDatasetsResponses[200]> {
  return withClient(async (client) => {
    const result = await _listPlansActualsDatasets({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/workspaces/{workspace_id}/plans-actuals/datasets";
    return processResult<ListPlansActualsDatasetsResponses[200]>(url, result);
  });
}

export async function getPlansActualsDataset(
  opts: Omit<GetPlansActualsDatasetData, "url">,
): Promise<GetPlansActualsDatasetResponses[200]> {
  return withClient(async (client) => {
    const result = await _getPlansActualsDataset({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url =
      result.response?.url ??
      "/api/v1/workspaces/{workspace_id}/plans-actuals/datasets/{dataset_id}";
    return processResult<GetPlansActualsDatasetResponses[200]>(url, result);
  });
}

export async function updatePlansActualsDatasetMetadata(
  opts: Omit<UpdatePlansActualsDatasetMetadataData, "url">,
): Promise<UpdatePlansActualsDatasetMetadataResponses[200]> {
  return withClient(async (client) => {
    const result = await _updatePlansActualsDatasetMetadata({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url =
      result.response?.url ??
      "/api/v1/workspaces/{workspace_id}/plans-actuals/datasets/{dataset_id}";
    return processResult<UpdatePlansActualsDatasetMetadataResponses[200]>(url, result);
  });
}

export async function listPlansActualsDatasetImports(
  opts: Omit<ListPlansActualsDatasetImportsData, "url">,
): Promise<ListPlansActualsDatasetImportsResponses[200]> {
  return withClient(async (client) => {
    const result = await _listPlansActualsDatasetImports({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url =
      result.response?.url ??
      "/api/v1/workspaces/{workspace_id}/plans-actuals/datasets/{dataset_id}/imports";
    return processResult<ListPlansActualsDatasetImportsResponses[200]>(url, result);
  });
}

export async function downloadPlansActualsImportOriginal(
  opts: Omit<DownloadPlansActualsImportOriginalData, "url">,
): Promise<DownloadPlansActualsImportOriginalResponses[200]> {
  return withClient(async (client) => {
    const result = await _downloadPlansActualsImportOriginal({
      client,
      responseStyle: "fields",
      throwOnError: false,
      parseAs: "blob",
      ...opts,
    });
    const url =
      result.response?.url ??
      "/api/v1/workspaces/{workspace_id}/plans-actuals/imports/{import_id}/original";
    if (!result.response?.ok) {
      return processResult<DownloadPlansActualsImportOriginalResponses[200]>(url, {
        ...result,
        error: await parseBlobError(result.error),
      });
    }
    return result.data as DownloadPlansActualsImportOriginalResponses[200];
  });
}

export async function listPlansActualsAttachments(
  opts: Omit<ListPlansActualsAttachmentsData, "url">,
): Promise<ListPlansActualsAttachmentsResponses[200]> {
  return withClient(async (client) => {
    const result = await _listPlansActualsAttachments({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url =
      result.response?.url ??
      "/api/v1/workspaces/{workspace_id}/plans-actuals/datasets/{dataset_id}/attachments";
    return processResult<ListPlansActualsAttachmentsResponses[200]>(url, result);
  });
}

export async function uploadPlansActualsAttachment(
  opts: Omit<UploadPlansActualsAttachmentData, "url">,
): Promise<UploadPlansActualsAttachmentResponses[201]> {
  return withClient(async (client) => {
    const result = await _uploadPlansActualsAttachment({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url =
      result.response?.url ??
      "/api/v1/workspaces/{workspace_id}/plans-actuals/datasets/{dataset_id}/attachments";
    return processResult<UploadPlansActualsAttachmentResponses[201]>(url, result);
  });
}

export async function downloadPlansActualsAttachment(
  opts: Omit<DownloadPlansActualsAttachmentData, "url">,
): Promise<DownloadPlansActualsAttachmentResponses[200]> {
  return withClient(async (client) => {
    const result = await _downloadPlansActualsAttachment({
      client,
      responseStyle: "fields",
      throwOnError: false,
      parseAs: "blob",
      ...opts,
    });
    const url =
      result.response?.url ??
      "/api/v1/workspaces/{workspace_id}/plans-actuals/datasets/{dataset_id}/attachments/{attachment_id}/content";
    if (!result.response?.ok) {
      return processResult<DownloadPlansActualsAttachmentResponses[200]>(url, {
        ...result,
        error: await parseBlobError(result.error),
      });
    }
    return result.data as DownloadPlansActualsAttachmentResponses[200];
  });
}

export async function deletePlansActualsAttachment(
  opts: Omit<DeletePlansActualsAttachmentData, "url">,
): Promise<undefined> {
  return withClient(async (client) => {
    const result = await _deletePlansActualsAttachment({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url =
      result.response?.url ??
      "/api/v1/workspaces/{workspace_id}/plans-actuals/datasets/{dataset_id}/attachments/{attachment_id}";
    return processResult<undefined>(url, result);
  });
}

export async function exportPlansActuals(
  opts: Omit<ExportPlansActualsData, "url">,
): Promise<ExportPlansActualsResponses[200]> {
  return withClient(async (client) => {
    const result = await _exportPlansActuals({
      client,
      responseStyle: "fields",
      throwOnError: false,
      parseAs: "blob",
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/workspaces/{workspace_id}/plans-actuals/export";
    if (!result.response?.ok) {
      return processResult<ExportPlansActualsResponses[200]>(url, {
        ...result,
        error: await parseBlobError(result.error),
      });
    }
    return result.data as ExportPlansActualsResponses[200];
  });
}

export async function getPlansActualsReport(
  opts: Omit<GetPlansActualsReportData, "url">,
): Promise<GetPlansActualsReportResponses[200]> {
  return withClient(async (client) => {
    const result = await _getPlansActualsReport({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/workspaces/{workspace_id}/plans-actuals/report";
    return processResult<GetPlansActualsReportResponses[200]>(url, result);
  });
}

export async function getApiV1Me(
  opts?: Omit<GetApiV1MeData, "url">,
): Promise<GetApiV1MeResponses[200]> {
  return withClient(async (client) => {
    const result = await _getApiV1Me({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...(opts ?? {}),
    });
    const url = result.response?.url ?? "/api/v1/me";
    return processResult<GetApiV1MeResponses[200]>(url, result);
  });
}

export async function getApiV1Config(
  opts?: Omit<GetApiV1ConfigData, "url">,
): Promise<GetApiV1ConfigResponses[200]> {
  return withClient(async (client) => {
    const result = await _getApiV1Config({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...(opts ?? {}),
    });
    const url = result.response?.url ?? "/api/v1/config";
    return processResult<GetApiV1ConfigResponses[200]>(url, result);
  });
}

export async function patchApiV1UserDefaultCompany(
  opts: Omit<PatchApiV1UserDefaultCompanyData, "url">,
): Promise<undefined> {
  return withClient(async (client) => {
    const result = await _patchApiV1UserDefaultCompany({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/user/default-company";
    return processResult<undefined>(url, result);
  });
}

export async function adminListUsers(
  opts?: Omit<AdminListUsersData, "url">,
): Promise<AdminListUsersResponses[200]> {
  return withClient(async (client) => {
    const result = await _adminListUsers({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...(opts ?? {}),
    });
    const url = result.response?.url ?? "/api/v1/admin/users";
    return processResult<AdminListUsersResponses[200]>(url, result);
  });
}

export async function adminGetUser(
  opts: Omit<AdminGetUserData, "url">,
): Promise<AdminGetUserResponses[200]> {
  return withClient(async (client) => {
    const result = await _adminGetUser({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/admin/users/{user_id}";
    return processResult<AdminGetUserResponses[200]>(url, result);
  });
}

export async function adminUpdateUser(opts: Omit<AdminUpdateUserData, "url">): Promise<undefined> {
  return withClient(async (client) => {
    const result = await _adminUpdateUser({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/admin/users/{user_id}";
    return processResult<undefined>(url, result);
  });
}

export async function adminAssignRole(
  opts: Omit<AdminAssignRoleData, "url">,
): Promise<AdminAssignRoleResponses[201]> {
  return withClient(async (client) => {
    const result = await _adminAssignRole({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/admin/users/{user_id}/roles";
    return processResult<AdminAssignRoleResponses[201]>(url, result);
  });
}

export async function adminRevokeRole(opts: Omit<AdminRevokeRoleData, "url">): Promise<undefined> {
  return withClient(async (client) => {
    const result = await _adminRevokeRole({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/admin/users/{user_id}/roles/{role}";
    return processResult<undefined>(url, result);
  });
}

export async function adminListCompanies(
  opts?: Omit<AdminListCompaniesData, "url">,
): Promise<AdminListCompaniesResponses[200]> {
  return withClient(async (client) => {
    const result = await _adminListCompanies({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...(opts ?? {}),
    });
    const url = result.response?.url ?? "/api/v1/admin/companies";
    return processResult<AdminListCompaniesResponses[200]>(url, result);
  });
}

export async function adminCreateCompany(
  opts: Omit<AdminCreateCompanyData, "url">,
): Promise<AdminCreateCompanyResponses[201]> {
  return withClient(async (client) => {
    const result = await _adminCreateCompany({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/admin/companies";
    return processResult<AdminCreateCompanyResponses[201]>(url, result);
  });
}

export async function adminGetCompany(
  opts: Omit<AdminGetCompanyData, "url">,
): Promise<AdminGetCompanyResponses[200]> {
  return withClient(async (client) => {
    const result = await _adminGetCompany({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/admin/companies/{company_id}";
    return processResult<AdminGetCompanyResponses[200]>(url, result);
  });
}

export async function adminUpdateCompany(
  opts: Omit<AdminUpdateCompanyData, "url">,
): Promise<AdminUpdateCompanyResponses[200]> {
  return withClient(async (client) => {
    const result = await _adminUpdateCompany({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/admin/companies/{company_id}";
    return processResult<AdminUpdateCompanyResponses[200]>(url, result);
  });
}

export async function adminListMembers(
  opts: Omit<AdminListMembersData, "url">,
): Promise<AdminListMembersResponses[200]> {
  return withClient(async (client) => {
    const result = await _adminListMembers({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/admin/companies/{company_id}/members";
    return processResult<AdminListMembersResponses[200]>(url, result);
  });
}

export async function adminAddMember(opts: Omit<AdminAddMemberData, "url">): Promise<undefined> {
  return withClient(async (client) => {
    const result = await _adminAddMember({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/admin/companies/{company_id}/members";
    return processResult<undefined>(url, result);
  });
}

export async function adminRemoveMember(
  opts: Omit<AdminRemoveMemberData, "url">,
): Promise<undefined> {
  return withClient(async (client) => {
    const result = await _adminRemoveMember({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/admin/companies/{company_id}/members/{user_id}";
    return processResult<undefined>(url, result);
  });
}

export async function adminListInvites(
  opts: Omit<AdminListInvitesData, "url">,
): Promise<AdminListInvitesResponses[200]> {
  return withClient(async (client) => {
    const result = await _adminListInvites({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/admin/companies/{company_id}/invites";
    return processResult<AdminListInvitesResponses[200]>(url, result);
  });
}

export async function adminRevokeInvite(
  opts: Omit<AdminRevokeInviteData, "url">,
): Promise<undefined> {
  return withClient(async (client) => {
    const result = await _adminRevokeInvite({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/admin/companies/{company_id}/invites/{invite_id}";
    return processResult<undefined>(url, result);
  });
}

export async function createCompanyInvite(
  opts: Omit<CreateCompanyInviteData, "url">,
): Promise<CreateCompanyInviteResponses[201]> {
  return withClient(async (client) => {
    const result = await _createCompanyInvite({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/companies/{company_id}/invites";
    return processResult<CreateCompanyInviteResponses[201]>(url, result);
  });
}

export async function getApiV1Companies(
  opts?: Omit<GetApiV1CompaniesData, "url">,
): Promise<GetApiV1CompaniesResponses[200]> {
  return withClient(async (client) => {
    const result = await _getApiV1Companies({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...(opts ?? {}),
    });
    const url = result.response?.url ?? "/api/v1/companies";
    return processResult<GetApiV1CompaniesResponses[200]>(url, result);
  });
}

export async function listCompanyWorkspaces(
  opts: Omit<ListCompanyWorkspacesData, "url">,
): Promise<ListCompanyWorkspacesResponses[200]> {
  return withClient(async (client) => {
    const result = await _listCompanyWorkspaces({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/companies/{company_id}/workspaces";
    return processResult<ListCompanyWorkspacesResponses[200]>(url, result);
  });
}

export async function createCompanyWorkspace(
  opts: Omit<CreateCompanyWorkspaceData, "url">,
): Promise<CreateCompanyWorkspaceResponses[201]> {
  return withClient(async (client) => {
    const result = await _createCompanyWorkspace({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/companies/{company_id}/workspaces";
    return processResult<CreateCompanyWorkspaceResponses[201]>(url, result);
  });
}

export async function getWorkspace(
  opts: Omit<GetWorkspaceData, "url">,
): Promise<GetWorkspaceResponses[200]> {
  return withClient(async (client) => {
    const result = await _getWorkspace({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/workspaces/{workspace_id}";
    return processResult<GetWorkspaceResponses[200]>(url, result);
  });
}

export async function patchWorkspace(
  opts: Omit<PatchWorkspaceData, "url">,
): Promise<PatchWorkspaceResponses[200]> {
  return withClient(async (client) => {
    const result = await _patchWorkspace({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/workspaces/{workspace_id}";
    return processResult<PatchWorkspaceResponses[200]>(url, result);
  });
}

export async function deleteWorkspace(
  opts: Omit<DeleteWorkspaceData, "url">,
): Promise<DeleteWorkspaceResponses[200]> {
  return withClient(async (client) => {
    const result = await _deleteWorkspace({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/workspaces/{workspace_id}";
    return processResult<DeleteWorkspaceResponses[200]>(url, result);
  });
}

export async function getWorkspaceContext(
  opts: Omit<GetWorkspaceContextData, "url">,
): Promise<GetWorkspaceContextResponses[200]> {
  return withClient(async (client) => {
    const result = await _getWorkspaceContext({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/workspaces/{workspace_id}/context";
    return processResult<GetWorkspaceContextResponses[200]>(url, result);
  });
}

export async function getWorkspaceIntegration(
  opts: Omit<GetWorkspaceIntegrationData, "url">,
): Promise<GetWorkspaceIntegrationResponses[200]> {
  return withClient(async (client) => {
    const result = await _getWorkspaceIntegration({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/workspaces/{workspace_id}/integrations/{provider}";
    return processResult<GetWorkspaceIntegrationResponses[200]>(url, result);
  });
}

export async function getWorkspaceIntegrationDealDateProperties(
  opts: Omit<GetWorkspaceIntegrationDealDatePropertiesData, "url">,
): Promise<GetWorkspaceIntegrationDealDatePropertiesResponses[200]> {
  return withClient(async (client) => {
    const result = await _getWorkspaceIntegrationDealDateProperties({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url =
      result.response?.url ??
      "/api/v1/workspaces/{workspace_id}/integrations/{provider}/deal-date-properties";
    return processResult<GetWorkspaceIntegrationDealDatePropertiesResponses[200]>(url, result);
  });
}

export async function getWorkspaceIntegrationPipelines(
  opts: Omit<GetWorkspaceIntegrationPipelinesData, "url">,
): Promise<GetWorkspaceIntegrationPipelinesResponses[200]> {
  return withClient(async (client) => {
    const result = await _getWorkspaceIntegrationPipelines({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url =
      result.response?.url ?? "/api/v1/workspaces/{workspace_id}/integrations/{provider}/pipelines";
    return processResult<GetWorkspaceIntegrationPipelinesResponses[200]>(url, result);
  });
}

export async function patchWorkspaceIntegration(
  opts: Omit<PatchWorkspaceIntegrationData, "url">,
): Promise<PatchWorkspaceIntegrationResponses[200]> {
  return withClient(async (client) => {
    const result = await _patchWorkspaceIntegration({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/workspaces/{workspace_id}/integrations/{provider}";
    return processResult<PatchWorkspaceIntegrationResponses[200]>(url, result);
  });
}

export async function deleteWorkspaceIntegration(
  opts: Omit<DeleteWorkspaceIntegrationData, "url">,
): Promise<DeleteWorkspaceIntegrationResponses[200]> {
  return withClient(async (client) => {
    const result = await _deleteWorkspaceIntegration({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/workspaces/{workspace_id}/integrations/{provider}";
    return processResult<DeleteWorkspaceIntegrationResponses[200]>(url, result);
  });
}

export async function listDatasets(
  opts: Omit<ListDatasetsData, "url">,
): Promise<ListDatasetsResponses[200]> {
  return withClient(async (client) => {
    const result = await _listDatasets({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/workspaces/{workspace_id}/datasets";
    return processResult<ListDatasetsResponses[200]>(url, result);
  });
}

export async function uploadDataset(
  opts: Omit<UploadDatasetData, "url">,
): Promise<UploadDatasetResponses[200]> {
  return withClient(async (client) => {
    const result = await _uploadDataset({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/workspaces/{workspace_id}/datasets/upload";
    return processResult<UploadDatasetResponses[200]>(url, result);
  });
}

export async function deleteDataset(
  opts: Omit<DeleteDatasetData, "url">,
): Promise<DeleteDatasetResponses[200]> {
  return withClient(async (client) => {
    const result = await _deleteDataset({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/workspaces/{workspace_id}/datasets/{dataset_id}";
    return processResult<DeleteDatasetResponses[200]>(url, result);
  });
}

export async function getDataset(
  opts: Omit<GetDatasetData, "url">,
): Promise<GetDatasetResponses[200]> {
  return withClient(async (client) => {
    const result = await _getDataset({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/workspaces/{workspace_id}/datasets/{dataset_id}";
    return processResult<GetDatasetResponses[200]>(url, result);
  });
}

export async function listDatasetRows(
  opts: Omit<ListDatasetRowsData, "url">,
): Promise<ListDatasetRowsResponses[200]> {
  return withClient(async (client) => {
    const result = await _listDatasetRows({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url =
      result.response?.url ?? "/api/v1/workspaces/{workspace_id}/datasets/{dataset_id}/rows";
    return processResult<ListDatasetRowsResponses[200]>(url, result);
  });
}

export async function exportDatasetRowsCsv(
  opts: Omit<ExportDatasetRowsCsvData, "url">,
): Promise<ExportDatasetRowsCsvResponses[200]> {
  return withClient(async (client) => {
    const result = await _exportDatasetRowsCsv({
      client,
      responseStyle: "fields",
      throwOnError: false,
      parseAs: "blob",
      ...opts,
    });
    const url =
      result.response?.url ?? "/api/v1/workspaces/{workspace_id}/datasets/{dataset_id}/rows/export";
    if (!result.response?.ok) {
      return processResult<ExportDatasetRowsCsvResponses[200]>(url, {
        ...result,
        error: await parseBlobError(result.error),
      });
    }
    return result.data as ExportDatasetRowsCsvResponses[200];
  });
}

export async function listDatasetFlags(
  opts: Omit<ListDatasetFlagsData, "url">,
): Promise<ListDatasetFlagsResponses[200]> {
  return withClient(async (client) => {
    const result = await _listDatasetFlags({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url =
      result.response?.url ?? "/api/v1/workspaces/{workspace_id}/datasets/{dataset_id}/flags";
    return processResult<ListDatasetFlagsResponses[200]>(url, result);
  });
}

export async function getWorkspaceDatasetChart(
  opts: Omit<GetWorkspaceDatasetChartData, "url">,
): Promise<GetWorkspaceDatasetChartResponses[200]> {
  return withClient(async (client) => {
    const result = await _getWorkspaceDatasetChart({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url =
      result.response?.url ??
      "/api/v1/workspaces/{workspace_id}/datasets/{dataset_id}/analytics/charts/{chart_type}";
    return processResult<GetWorkspaceDatasetChartResponses[200]>(url, result);
  });
}

export async function getWorkspaceChart(
  opts: Omit<GetWorkspaceChartData, "url">,
): Promise<GetWorkspaceChartResponses[200]> {
  return withClient(async (client) => {
    const result = await _getWorkspaceChart({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url =
      result.response?.url ?? "/api/v1/workspaces/{workspace_id}/analytics/charts/{chart_type}";
    return processResult<GetWorkspaceChartResponses[200]>(url, result);
  });
}

export async function getWorkspaceDatasetArrSummary(
  opts: Omit<GetWorkspaceDatasetArrSummaryData, "url">,
): Promise<GetWorkspaceDatasetArrSummaryResponses[200]> {
  return withClient(async (client) => {
    const result = await _getWorkspaceDatasetArrSummary({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url =
      result.response?.url ??
      "/api/v1/workspaces/{workspace_id}/datasets/{dataset_id}/reports/arr-summary";
    return processResult<GetWorkspaceDatasetArrSummaryResponses[200]>(url, result);
  });
}

export async function getWorkspaceDatasetTopAccounts(
  opts: Omit<GetWorkspaceDatasetTopAccountsData, "url">,
): Promise<GetWorkspaceDatasetTopAccountsResponses[200]> {
  return withClient(async (client) => {
    const result = await _getWorkspaceDatasetTopAccounts({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url =
      result.response?.url ??
      "/api/v1/workspaces/{workspace_id}/datasets/{dataset_id}/reports/top-accounts";
    return processResult<GetWorkspaceDatasetTopAccountsResponses[200]>(url, result);
  });
}

export async function getWorkspaceDatasetAccountDeals(
  opts: Omit<GetWorkspaceDatasetAccountDealsData, "url">,
): Promise<GetWorkspaceDatasetAccountDealsResponses[200]> {
  return withClient(async (client) => {
    const result = await _getWorkspaceDatasetAccountDeals({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url =
      result.response?.url ??
      "/api/v1/workspaces/{workspace_id}/datasets/{dataset_id}/reports/account-deals";
    return processResult<GetWorkspaceDatasetAccountDealsResponses[200]>(url, result);
  });
}

export async function getWorkspaceDatasetAccountPerformance(
  opts: Omit<GetWorkspaceDatasetAccountPerformanceData, "url">,
): Promise<GetWorkspaceDatasetAccountPerformanceResponses[200]> {
  return withClient(async (client) => {
    const result = await _getWorkspaceDatasetAccountPerformance({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url =
      result.response?.url ??
      "/api/v1/workspaces/{workspace_id}/datasets/{dataset_id}/reports/account-performance";
    return processResult<GetWorkspaceDatasetAccountPerformanceResponses[200]>(url, result);
  });
}

export async function listExclusionRules(
  opts: Omit<ListExclusionRulesData, "url">,
): Promise<ListExclusionRulesResponses[200]> {
  return withClient(async (client) => {
    const result = await _listExclusionRules({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/workspaces/{workspace_id}/exclusion-rules";
    return processResult<ListExclusionRulesResponses[200]>(url, result);
  });
}

export async function createExclusionRule(
  opts: Omit<CreateExclusionRuleData, "url">,
): Promise<CreateExclusionRuleResponses[201]> {
  return withClient(async (client) => {
    const result = await _createExclusionRule({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url = result.response?.url ?? "/api/v1/workspaces/{workspace_id}/exclusion-rules";
    return processResult<CreateExclusionRuleResponses[201]>(url, result);
  });
}

export async function deleteExclusionRule(
  opts: Omit<DeleteExclusionRuleData, "url">,
): Promise<DeleteExclusionRuleResponses[200]> {
  return withClient(async (client) => {
    const result = await _deleteExclusionRule({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url =
      result.response?.url ??
      "/api/v1/workspaces/{workspace_id}/exclusion-rules/{exclusion_rule_id}";
    return processResult<DeleteExclusionRuleResponses[200]>(url, result);
  });
}

export async function postWorkspaceIntegrationSync(
  opts: Omit<PostWorkspaceIntegrationSyncData, "url">,
): Promise<PostWorkspaceIntegrationSyncResponses[200]> {
  return withClient(async (client) => {
    const result = await _postWorkspaceIntegrationSync({
      client,
      responseStyle: "fields",
      throwOnError: false,
      ...opts,
    });
    const url =
      result.response?.url ?? "/api/v1/workspaces/{workspace_id}/integrations/{provider}/sync";
    return processResult<PostWorkspaceIntegrationSyncResponses[200]>(url, result);
  });
}
